import axios from 'axios';
import {API} from "@/services/url";

export default {
	getPaymentHistoryList : function (success, error) {
		axios.get(API.payment.historyList.all)
			.then(r => success(r.data.paymentHistoryList))
			.catch(e => error(e.response.data.message));
	},

	addPaymentForAnInvoice : function (paymentHistory, success, error) {
		axios.post(API.payment.create, paymentHistory)
			.then(r => success(r.data.paymentHistoryList))
			.catch(e => error(e.response.data.message));
	},

	getPaymentHistoryListOfAnInvoice : function (invoiceId, success, error) {
		axios.get(API.payment.historyList.invoice + invoiceId)
			.then(r => success(r.data.paymentHistoryList))
			.catch(e => error(e.response.data.message));
	},

	downloadInvoice : function (paymentHistoryId, success, error) {
		axios.get(API.payment.downloadInvoice + paymentHistoryId, {
			responseType : "blob"
		})
			.then(r => {
				let fileURL = window.URL.createObjectURL(new Blob([r.data]));
				let fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'invoice-for-payment-id-' + paymentHistoryId + '.pdf');
				document.body.appendChild(fileLink);

				fileLink.click();
			})
			.catch(e => error(e));
	}
}
